<template>
  <div>


    <div class="header">
      <div class="container">
        <div class="float-right pt-3">
          <button class="btn btn-primary btn-donate" v-on:click="donate">
          
            <template v-if="loading">
              <app-loader/>
            </template>
            <template v-else>
              Ayudar ahora
            </template>
            
          </button>
        </div>

        <div class="pt-1 pb-1">
          <img src="../assets/website/lov.svg" class="love">
          <img src="../assets/website/logo.png" alt="" class="logo">
          
          <div class="d-inline sol">
            #solidaridad
          </div>
        </div>
      </div>
    </div>


    <div class="bg text-center">
      <h2>Ayuda a las personas que más lo necesitan</h2>
      
      <button class="btn btn-primary btn-donate btn-lg" v-on:click="donate">
        <template v-if="loading">
          <app-loader/>
        </template>
        <template v-else>
          Ayudar ahora
        </template>
    </button>
    </div>
    
    <div class="content mt-5 mb-5">
      <div class="container people">
        <div class="row">
          <div class="col">
            <img src="../assets/website/p/1.svg">            
          </div>
          <div class="col">
            <img src="../assets/website/p/2.svg">            
          </div>
          <div class="col">
            <img src="../assets/website/p/3.svg">            
          </div>
          <div class="col">
            <img src="../assets/website/p/4.svg">            
          </div>
          <div class="col">
            <img src="../assets/website/p/5.svg">            
          </div>
          <div class="col">
            <img src="../assets/website/p/6.svg">            
          </div>
          <div class="col">
            <img src="../assets/website/p/7.svg">            
          </div>
          <div class="col">
            <img src="../assets/website/p/8.svg">            
          </div>
          <div class="col">
            <img src="../assets/website/p/9.svg">            
          </div>
          <div class="col">
            <img src="../assets/website/p/10.svg">            
          </div>
        </div>
      </div>
    </div>



   <div class="content mt-5 mb-5" id="features">
      <div class="container">
        <div class="row">
        <div class="col-md-6">

          <h1 class="mb-4 mt-3">
           Aporta tu <span style="color: #fa496e;">granito de arena</span>
          </h1>

          <div class="promotion-product">
            <img src="../assets/website/wallet.png"/>
            <h3>Ayudaremos a las familias que <span style="color: #fa496e;">más lo necesitan</span> o que la están pasando mal con esta crisis</h3>
          </div>

          <div class="promotion-product">
            <img src="../assets/website/wallet.png"/>
            <h3>Entregaremos por medio de  <span style="color: #fa496e;">tenderos</span> las ayudas favoreciendo así  <span style="color: #fa496e;">dos familias</span></h3>
          </div>

          <div class="promotion-product">
            <img src="../assets/website/wallet.png"/>
            <h3>Te informaremos de las ayudas <span style="color: #fa496e;">en todo momento</span></h3>
          </div>

          <div class="promotion-product">
            <img src="../assets/website/wallet.png"/>
            <h3>Recuerda que <span style="color: #fa496e;">unidos somos más</span></h3>
          </div>
          
          


        </div>
        <div class="col-md-6">
          
          <div class="row">
            <div class="col-4" v-for="(img, index) in imgs" :key="index">
              <div class="box-product">
                <img :src="img" alt=""  class="cash"/>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>



  <b-modal id="donate" ref="donate" hide-header hide-footer centered size="lg">

    <div class="form-group">
      <label>¿Cuánto quieres aportar?</label>

      <template v-if="!other">
        <div class="text-center row prices price-sug">
          <div class="position-relative col-6 col-md-3 mb-3">
            <img class="box-img" src="../assets/website/d.png" alt="">
            <div class="price-sug"  v-on:click="valueToDonate = 10000" :class="{ 'active':   10000 == valueToDonate }">
              $10.000
            </div>
            
          </div>
           <div class="position-relative col-6 col-md-3 mb-3">
            <img class="box-img" src="../assets/website/o.png" alt="">
            <div class="price-sug"  v-on:click="valueToDonate = 20000" :class="{ 'active': 20000 == valueToDonate }">
              $20.000
            </div>
          </div>
           <div class="position-relative col-6 col-md-3 mb-3">
            <img class="box-img" src="../assets/website/n.png" alt="">
            <div class="price-sug" v-on:click="valueToDonate = 50000" :class="{ 'active': 50000 ==      valueToDonate }">
              $50.000
            </div>
          </div>
           <div class="position-relative col-6 col-md-3 mb-3">
            <img class="box-img" src="../assets/website/a.png" alt="">
            <div class="price-sug"  v-on:click="valueToDonate = 100000" :class="{ 'active': 100000 == valueToDonate }">
              $100.000
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <money class="form-control price-other" v-model="valueToDonate"/>
      </template>
    </div>
    

    <div class="text-center">
      <button type="button" class="other btn btn btn-primary btn-donate mr-4" v-on:click="other = true">
            Otro
      </button>
      <button class="btn btn-primary btn-donate btn-close mr-4" v-on:click="$refs.donate.hide()">
        Cancelar
      </button>
      <button class="btn btn-primary btn-donate" v-on:click="donateFinal">
          <template v-if="loading">
            <app-loader/>
          </template>
          <template v-else>
            Ayudar con ${{money(valueToDonate)}}
          </template>
      </button>
    </div>
  </b-modal>

    <div class="footer text-center">
      SuperPagos - Todos los derechos reservados | Desarrollado por <a href="https://blackbozz.com" target="_blank">BlackBozz Group</a>
    </div>
  </div>
</template>
<script>
import { CREATE_CONTACT } from "@/store/actions.type";
import img1 from "@/assets/website/20.png";
import img2 from "@/assets/website/50.png";
import img3 from "@/assets/website/100.png";
import img4 from "@/assets/website/1.png";
import img5 from "@/assets/website/2.jpeg";
import img6 from "@/assets/website/3.jpeg";
import AppLoader from "@/components/AppLoader";

export default {
  data() {
    return {
      form: {},
      values: [10000, 20000, 50000, 100000],
      handler: null,
      loading: false,
      valueToDonate: 0,
      other: false,
      imgs: [
        img1,
        img2,
        img3,
        img4,
        img5,
        img6
      ]
    };
  },
  components: {
    AppLoader
  },
  mounted() {
    this.handler = ePayco.checkout.configure({
      key: '371243bace5af550a30015705b62874b',
      test: false
    })
  },
  methods: {
    sendMessage() {
      this.$store
        .dispatch(CREATE_CONTACT, this.form)
        .then(data => {
          this.$snotify.success(data.message);
        })
        .catch(err => {
          this.$snotify.error(err.message);
        });
    },
    donateFinal() {
      this.loading = true;
      var data = {
        //Parametros compra (obligatorio)
        name: "Ayudas COVID",
        description: "Ayudas para mercados COVID-19",
        invoice: Date.now(),
        currency: "cop",
        amount: this.valueToDonate,
        tax_base: "0",
        tax: "0",
        country: "co",
        lang: "es",
        external: "true",
        //Atributos opcionales
        confirmation: "https://superpagos.com",
        response: "https://superpagos.com",

        //Atributos cliente
        // name_billing: "Andres Perez",
        // address_billing: "Carrera 19 numero 14 91",
        // type_doc_billing: "cc",
        // mobilephone_billing: "3050000000",
        // number_doc_billing: "100000000"
      };

      this.handler.open(data)
    },
    donate() {
      this.$refs.donate.show();
    }
  }
};
</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=Sniglet&display=swap');
@import url('https://fonts.googleapis.com/css?family=Chewy&display=swap');

body {
  margin: 0;
  padding: 0;
  font-family: 'Sniglet', sans-serif;
  
}
h2 {
  color: #7c46fe;
  font-size: 50px;
  text-align: center;
}


.header {
  position: fixed;
  left: 0;
  width: 100%;
  top:0;
  background: rgba(255,255,255,1);
  z-index: 1000;
  img {
    max-height: 100%;
  }
  .logo {
    height: 35px;
  }
  .love {
    width: 60px;
    height: 60px;
  }
  .sol {
    font-size: 25px;
    border-left: 2px solid #aaa;
    color: #aaa;
    padding-left: 10px;
    margin-left: 10px;
  }
}

.content h1 {
  color: black;
  font-size: 50px;
  font-weight: bold;
}

.functions {
  margin-top: 100px;
  h1 {
    font-weight: bold;
  }
}

.box-circle {
  display: block;
  max-width: 200px;
  max-height: 200px;
  padding: 20px;
  box-shadow: 7px 0px 14px 2px rgba(0, 0, 0, 0.2);
  border-radius: 100%;
  margin: 0 auto;
  animation: 0.5s;
  background-image: transparent;
  img {
    max-width: 100%;
  }
  // &:hover {
  //   background-image: linear-gradient(to bottom, #00cf96, #0d5f4a);
  // }
}

.box {
  background: #fff;
  padding: 10px 20px;
  border-radius: 20px;
}

.plans {
  position: relative;
  margin-top: 200px;
  img {
    max-width: 100%;
  }
  .plans-content {
    position: absolute;
    top: 200px;
  }

  .contact-content {
    position: absolute;
    top: 30%;
    left: 150px;
    width: 50%;
    ::-webkit-input-placeholder {
      color: #00cf96;
      font-weight: bold;
      font-size: 20px;
    }

    h1 {
      font-size: 30px;
    }
  }
}

.btn {
  font-weight: 900;
  width: auto;
  &.btn-login {
    background: white;
    border-color: white;
    color: #05d099;
  }
  &.outline {
    color: white;
    background: transparent;
    border: 2px solid white;
  }
  &.radius {
    border-radius: 100px;
  }
  &.background {
    background: #05d099;
    color: #fff;
  }
}


.website-need {
  min-height: 75vh;
  @media screen and (max-width: 600px) {
    min-height: 0;
    h2 {
      color: #333;
      text-align: center;
      padding: 40px 0;
    }
  }
}

.footer {
  display: block;
  width: 100%;
  padding: 20px;
  background: #fa496e;
  color: white;
  border-top: 1px solid #00976e;
}

.cash-products {
  position: relative;
  height: 500px;
  margin-top: 200px;
  .products {
    width: 350px;
    height: 500px;
    background: rgba(14, 99, 154, 0.82);
    border-radius: 20px;
    display: block;
    position: absolute;
    z-index: 100;
    box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.49);
    transform: skew(10deg, 10deg);

    .product {
      position: absolute;
      color: white;
      text-align: center;
      width: 100px;
      img {
        width: 80px;
      }
    }
    .p1 {
      left: 120px;
      top: 50px;
    }
    .p2 {
      left: 20px;
      top: 200px;
    }
    .p3 {
      left: 120px;
      top: 210px;
    }
    .p4 {
      left: 220px;
      top: 220px;
    }
    .p5 {
      left: 120px;
      top: 350px;
    }
  }
  
  .cash {
    position: absolute;
    transform: rotate(15deg);
    top: 120px;
    left: -180px;
    width: 450px;

    &.cash.c3 {
      top: -52px!important;
      left: -68px!important;
      transform: rotate(59deg)!important;
    }
    &.cash.c2 {
      top: -19px!important;
      left: -130px!important;
      transform: rotate(24deg)!important;
    }
  }
}

.promotion-product {
  margin-bottom: 30px;
  h3 {
    font-size: 22px;
  }
  img {
    float: left;
    height: 40px;
    margin-right: 10px;
  }
}

.people {
  img {
    max-width: 100%;
  }
}

.bg {
  margin-top: 80px;
  background: url("../assets/website/p/b.jpeg");
  background-size: cover;
  background-position: center;
  padding: 100px 0;
  h2 {
    color: white;
    text-shadow: 0 0 15px #000;
  }
}

.btn-donate {
  background: #fa496e;
  border: none;
  font-size: 20px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.41);
  &.btn-lg {
    padding: 15px;
    min-width: 200px;
    box-shadow: 0 0 15px #000;
  }
  &.btn-close {
    background: #aaa;
  }
}
.box-product {
  box-shadow: 0 10px 10px rgba(0,0,0,.12);
  cursor: pointer;
  border-radius: 8px;
  margin-bottom: 15px;
  padding: 30px 10px 10px;
  background: #fff;
  text-align: center;

  img {
    max-width: 100%;
    height: 70px;
  }
}
 .other {      
    border-radius: 50px!important;    
  }

  .position-relative {
    position: relative;
  }
.prices {
  .box-img {
    width: 100%;
  }
  .price-sug {
    position: absolute;
    background: #03a9f4;
    color: white;
    padding: 5px 10px;
    border-radius: 50px;
    cursor: pointer;
    -webkit-transition: .4s;
    transition: .4s;
    bottom: 5px;
    right: 56px;
    &:hover {
      background: #0785be;
    }
    &.active {
      background: #00496c;
      box-shadow: 0 0 10px #673AB7;
    }
  }
}
.price-other {
  background: #eee;
  border: none;
  font-size: 20px;
  border-radius: 50px;
  display: block;
  max-width: 500px;
  margin: 20px auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue